import { z } from "zod";

export const authenticationProvidersSchema = z.enum(["credentials", "duende"]);
export type AuthenticationProvider = z.infer<
    typeof authenticationProvidersSchema
>;
